import { useState, useEffect } from "react";
import './Assistance.css';
import { pagesDuSiteService, Guide } from "../../services/pagesDuSiteService";
import ContentSkeleton from "../../composants/Skeleton/ContentSkeleton";

// Page "Tutoriel" (lien direct du footer -> /assistance). Le titre, les onglets
// (FAQ / Glossaire / Contact / Tickets) et le bouton de telechargement PDF ont
// ete retires : la navigation Assistance passe desormais par les liens directs
// du footer (Tutoriel, Guide methodologique, Nous contacter).
export default function CentralisPage() {
  const [guides, setGuides] = useState<Guide[]>([]);
  const [guidesLoading, setGuidesLoading] = useState(true);

  useEffect(() => {
    pagesDuSiteService.getGuides().then(setGuides).catch(() => { }).finally(() => setGuidesLoading(false));
  }, []);

  return (
    <div className="assistance-container">
      <div className="guides-container">
        {guidesLoading ? <ContentSkeleton variant="guides" /> : guides.map((guide, i) => {
          const youtubeId = guide.youtube_url
            ? (() => { try { return new URL(guide.youtube_url!).searchParams.get("v"); } catch { return null; } })()
            : null;
          return (
            <div key={i} className="guide-card">
              {youtubeId && (
                <div className="guide-video-wrapper">
                  <iframe
                    src={`https://www.youtube.com/embed/${youtubeId}`}
                    title={guide.titre}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
